import * as React from 'react';

import { getTimeAgoValue } from 'helpers/date';

import Info from 'assets/icons/status/icon-info-16.svg';

import { Bar } from 'basics/loaders/ContentPlaceholder/ContentPlaceholder.styled';
import Tooltip, { TOOLTIP_POSITION } from 'basics/Tooltip';

import { Header, Title, LastUpdated, TooltipInner, Retry } from './RewardsList.styled';

const RewardsListHeader = ({
    updatedAt,
    loading = true,
    error,
    onRetry,
}: {
    updatedAt?: string;
    loading?: boolean;
    error?: boolean;
    onRetry?: () => void;
}) => (
    <Header>
        <Title>LP Rewards by Market</Title>

        <LastUpdated>
            <span>
                {error ? (
                    <Retry onClick={onRetry}>Unable to load rewards. Try again</Retry>
                ) : updatedAt ? (
                    `Last updated ${getTimeAgoValue(new Date(updatedAt).getTime())}`
                ) : loading ? (
                    <Bar as="span" $width="20rem" $height="1.4rem" />
                ) : (
                    'Last updated —'
                )}
            </span>
            <Tooltip
                content={
                    <TooltipInner>
                        Market rewards are updated once a day at a random time.
                    </TooltipInner>
                }
                position={TOOLTIP_POSITION.bottom}
                showOnHover
            >
                <Info />
            </Tooltip>
        </LastUpdated>
    </Header>
);
export default RewardsListHeader;
